import React, { useEffect, useRef, useState } from 'react';
import './styles.css';
import ButtonDownload from '../ButtonDownload';
import AppNameSVG from '../AppNameSVG';
import AppLogoSVG from '../AppLogoSVG';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

import quotes from '../../assets/quotes.png';

import { ScrollTrigger } from 'gsap/all';
import Features from '../Features';
import Section3 from '../Section3';
import Quote from '../Quotes';

import iconGuest from '../../assets/icon.png';

gsap.registerPlugin(ScrollTrigger);

const quotesData = [
  {
    imageSrc: iconGuest,
    text: 'As a social media manager, I juggle 4 different WhatsApp accounts. Before, it was chaos! Now, everything’s organized in one place. I can finally focus on what matters!',
    author: 'Ana L., Social Media Manager',
  },
  {
    imageSrc: iconGuest,
    text: 'Set everything up in 15 minutes? I thought it was an exaggeration, but it’s real! Even my non-tech-savvy coworker managed to configure it without help.',
    author: 'Pedro S., Project Analyst',
  },
  {
    imageSrc: iconGuest,
    text: 'I save at least 1 hour a day by not switching between apps and accounts. The category-based organization has transformed my productivity!',
    author: 'Mariana F., Freelance Consultant',
  },
  {
    imageSrc: iconGuest,
    text: 'My screen used to be a mess of tabs and windows. Now, I only see what I need, when I need it. My digital anxiety has dropped dramatically.',
    author: 'Laura P., Student & Influencer',
  },
];

const Home = () => {
  const section1Ref = useRef(null);
  const canvasRef = useRef(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useGSAP(() => {
    // gsap.set('.section-1', {
    //   clipPath: 'polygon(14% 0%, 72% 0%, 90% 90%, 0% 100%',
    //   borderRadius: '0 0 40% 10%',
    // });

    // gsap.from('.section-1', {
    //   clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%',
    //   borderRadius: '0 0 0 0',
    //   ease: 'power1.inOut',
    //   scrollTrigger: {
    //     trigger: '.section-1',
    //     start: 'center center',
    //     end: 'bottom center',
    //     scrub: true,
    //   },
    // });
    if (!isMobile) {
      gsap.set('.section-1', {
        // clipPath: 'polygon(0 4%, 100% 4%, 94% 93%, 8% 93%',
        borderRadius: '0 0 50% 50%',
        scale: 0.8,
      });

      gsap.from('.section-1', {
        // clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%',
        borderRadius: '0 0 0 0',
        scale: 1,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: '.section-1',
          start: 'center center',
          end: 'bottom center',
          scrub: true,
        },
      });
      gsap.set('.title-quotes', {
        translateX: 1,
        opacity: 1,
        transformOrigin: '50% 50%',
        transformPerspective: 1000,
      });

      gsap.from('.title-quotes', {
        translateX: -50,
        opacity: 0,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: '.title-quotes',
          start: 'top bottom',
          end: 'top-=100 center',
          scrub: true,
        },
      });

      gsap.set('.description-quotes', {
        translateX: 1,
        opacity: 1,
        transformOrigin: '50% 50%',
        transformPerspective: 1000,
      });

      gsap.from('.description-quotes', {
        translateX: -100,
        opacity: 0,
        ease: 'power1.inOut',
        scrollTrigger: {
          trigger: '.description-quotes',
          start: 'top bottom',
          end: 'top center',
          scrub: true,
        },
      });
    }

    const quotes = document.querySelectorAll('.quote');
    quotes.forEach((quote) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: quote,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      });

      gsap.set(quote, {
        scale: 0.85,
        opacity: 0.5,
        translateX: '150px',
      });

      tl.to(quote, {
        scale: 1,
        opacity: 1,
        translateX: '0px',
        ease: 'power1.inOut',
      }).to(quote, {
        scale: 0.85,
        opacity: 0.5,
        translateX: '150px',
        ease: 'power1.inOut',
      });
    });
  });

  // dots effect

  useEffect(() => {
    if (section1Ref.current && canvasRef.current) {
      let section1 = document.querySelector('.section-1');
      let canvas = document.querySelector('#dotsCanvas');
      canvas.width = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;

      let ctx = canvas.getContext('2d');

      let dots = [];
      let arrayColors = ['#fff', '#ca9cff', '#867cbe', '#fff', '#fffcdf'];

      let numberOfDots = isMobile ? 30 : 200;

      for (let i = 0; i < numberOfDots; i++) {
        dots.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 2 + 1,
          color: arrayColors[Math.floor(Math.random() * arrayColors.length)],
          velocityX: (Math.random() - 0.5) * 0.4,
          velocityY: (Math.random() - 0.5) * 0.4,
          targetX: null,
          targetY: null,
        });
      }

      const drawDots = () => {
        dots.forEach((dot) => {
          ctx.fillStyle = dot.color;
          ctx.beginPath();
          ctx.arc(dot.x, dot.y, dot.size, 0, Math.PI * 2);
          ctx.fill();
        });

        // line each dots effect

        dots.forEach((dotA, i) => {
          dots.forEach((dotB, j) => {
            if (i !== j) {
              let dx = dotA.x - dotB.x;
              let dy = dotA.y - dotB.y;
              let distance = Math.sqrt(dx * dx + dy * dy);

              if (distance < 120) {
                let opacity = 1 - distance / 120;
                ctx.strokeStyle = `rgba(255, 255, 255, ${opacity})`;
                ctx.lineWidth = 0.15;
                ctx.beginPath();
                ctx.moveTo(dotA.x, dotA.y);
                ctx.lineTo(dotB.x, dotB.y);
                ctx.stroke();
              }
            }
          });
        });
      };

      const lerp = (start, end, amount) => start + (end - start) * amount;

      let mouse = { x: null, y: null };

      section1.addEventListener('mousemove', (event) => {
        mouse.x = event.pageX - section1.getBoundingClientRect().left;
        mouse.y = event.pageY - section1.getBoundingClientRect().top;
      });

      section1.addEventListener('mouseout', () => {
        mouse.x = null;
        mouse.y = null;
      });

      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        dots.forEach((dot) => {
          dot.x += dot.velocityX;
          dot.y += dot.velocityY;

          if (dot.x <= 0 || dot.x >= canvas.width) dot.velocityX *= -1;
          if (dot.y <= 0 || dot.y >= canvas.height) dot.velocityY *= -1;
        });

        drawDots();

        if (mouse.x !== null && mouse.y !== null) {
          dots.forEach((dot) => {
            let distance = Math.sqrt(
              (mouse.x - dot.x) ** 2 + (mouse.y - dot.y) ** 2
            );

            if (distance < 200) {
              if (dot.targetX === null) dot.targetX = dot.x;
              if (dot.targetY === null) dot.targetY = dot.y;

              dot.targetX = lerp(dot.targetX, mouse.x, 0.1);
              dot.targetY = lerp(dot.targetY, mouse.y, 0.1);

              ctx.strokeStyle = dot.color;
              ctx.lineWidth = 0.5;
              ctx.beginPath();
              ctx.moveTo(dot.x, dot.y);
              ctx.lineTo(dot.targetX, dot.targetY);
              ctx.stroke();
            } else {
              dot.targetX = null;
              dot.targetY = null;
            }
          });
        }

        requestAnimationFrame(animate);
      };

      animate();
    }
  }, [isMobile]);

  // end dots

  return (
    <>
      <section ref={section1Ref} className="section-1 section">
        <div className="div-animation w-dvw">
          <AppLogoSVG
            className="-z-50"
            width="100%"
            height="100%"
            animation={true}
          />
          <AppNameSVG
            // className="w-1/3"
            width="600"
            height="100%"
            animation={true}
          />
        </div>

        <canvas ref={canvasRef} id="dotsCanvas"></canvas>
      </section>
      <div className="box p-10 w-dvw">
        <p className="text-white font-bold text-xl sm:text-3xl lg:text-4xl text-right max-w-[75%]">
          Stop wasting time jumping from one account to another
        </p>
        <ButtonDownload link="/pricing" text="Get Started" />
      </div>
      <Features isMobile={isMobile} />

      <Section3 isMobile={isMobile} />
      <section
        id="reviews"
        className="min-h-dvh bg-gradient-to-l from-black to-gray-900 flex flex-col lg:flex-row justify-between text-white section-4"
      >
        <div className="flex flex-col justify-between w-[100dvw] lg:w-[50dvw]">
          <div className="mt-24 flex flex-col items-center justify-center">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl w-max font-bold mb-8 title-quotes">
              Read what our customers <br /> love about us
            </h1>
            <h4 className="w-2/3 text-slate-300 description-quotes text-lg 2xl:text-xl mb-16">
              From effortless multitasking to ironclad security, users praise
              how <span className="font-bold text-white">AllAppsUnited</span>{' '}
              transforms chaos into a streamlined workspace — with all their
              apps, accounts, and data in one place.
            </h4>
          </div>

          <div className="mb-24 hidden lg:flex flex-col justify-center align-middle text-center">
            <h1 className="font-bold text-xl sm:text-xl lg:text-2xl 2xl:text-3xl">
              Get All the Tools You Need In a Single Platform
            </h1>
            <ButtonDownload
              link="/pricing"
              className="button-bigger"
              text="Get Started"
            />
          </div>
        </div>
        <div className="flex flex-col items-center gap-0 w-dvw lg:w-[50dvw]">
          {quotesData.map((quote, index) => (
            <Quote
              key={index}
              imageSrc={quote.imageSrc}
              text={quote.text}
              author={quote.author}
              quotesIcon={quotes}
            />
          ))}
        </div>
        <div className="mb-24 mt-24 lg:hidden flex flex-col justify-center align-middle text-center">
          <h1 className="font-bold text-xl sm:text-xl lg:text-2xl 2xl:text-3xl">
            Get All the Tools You Need In a Single Platform
          </h1>
          <ButtonDownload
            link="/pricing"
            className="button-bigger"
            text="Get Started"
          />
        </div>
      </section>
    </>
  );
};

export default Home;
